(function(){
  if (window.__spCartNestInit) return;
  window.__spCartNestInit = true;

  function fmtMoney(cents){
    var n = (cents || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function escHtml(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Per-month stone colors. Matches the drawer and step-3 snippet so the
  // shopper sees the same color across every surface.
  var BIRTH_COLOR = {
    'January':'#7B1F2B','February':'#7B3BA6','March':'#7FC7D9',
    'April':'#E8ECEF','May':'#1F6F4A','June':'#4A7C5C',
    'July':'#9B1B2F','August':'#8BAD3B','September':'#0F3D8A',
    'October':'#C94B7D','November':'#CB8A1E','December':'#30A8A0'
  };

  function birthstoneIcon(color){
    // Small faceted gem outlined in navy with the table (inner octagon)
    // filled in the stone's color. Outline stays navy for brand consistency.
    var fill = color || 'transparent';
    return '<svg viewBox="0 0 48 48" fill="none" stroke="#0b1d2e" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
         + '<circle cx="24" cy="24" r="14"/>'
         + '<polygon points="24,14 31,17 34,24 31,31 24,34 17,31 14,24 17,17" fill="' + fill + '" fill-opacity="0.88"/>'
         + '</svg>';
  }

  function stoneColorFor(prop){
    if (!prop) return null;
    var m = String(prop).match(/^([^·]+)/);
    if (!m) return null;
    return BIRTH_COLOR[m[1].trim()] || null;
  }

  function labelFor(addon){
    var p = addon.properties || {};
    if (p._extra_type === 'birthstone' && p.Birthstone){
      return 'Birthstone \u00b7 <em>' + escHtml(p.Birthstone) + '</em>';
    }
    return escHtml(p.Extra || addon.product_title);
  }

  // Real product imagery for the non-birthstone extras. Same PNG assets
  // wired into the Setting PDP drawer and Step 3 card.
  var EXTRA_IMG = {
    euroshank: 'https://cdn.shopify.com/s/files/1/0708/5876/8690/t/205/assets/sp-euroshank.png',
    twotone:   'https://cdn.shopify.com/s/files/1/0708/5876/8690/t/205/assets/sp-twotone.png'
  };

  function iconForAddon(p){
    var type = p._extra_type;
    if (type === 'birthstone'){
      return '<span class="sp-cart-nest__icon" aria-hidden="true">'
           + birthstoneIcon(stoneColorFor(p.Birthstone))
           + '</span>';
    }
    if (EXTRA_IMG[type]){
      return '<span class="sp-cart-nest__icon sp-cart-nest__icon--img" aria-hidden="true">'
           + '<img src="' + EXTRA_IMG[type] + '" alt="" loading="lazy">'
           + '</span>';
    }
    return '';
  }

  function buildIncludesHtml(addons){
    var rows = addons.map(function(a){
      var p = a.properties || {};
      return '<li class="sp-cart-nest__line">'
           + iconForAddon(p)
           + '<span class="sp-cart-nest__name">' + labelFor(a) + '</span>'
           + '<span class="sp-cart-nest__price">+' + fmtMoney(a.final_line_price || a.final_price || a.price) + '</span>'
           + '</li>';
    }).join('');
    return '<div class="sp-cart-nest" data-sp-cart-nest>'
         + '<div class="sp-cart-nest__eyebrow">Includes</div>'
         + '<ul class="sp-cart-nest__list">' + rows + '</ul>'
         + '</div>';
  }

  function hideAddonRow(key){
    var row = document.querySelector('.sw-item[data-key="' + key + '"]');
    if (row) row.setAttribute('data-sp-addon', 'true');
  }

  function markNested(node){
    // Attach a cleanup hook so cascade-remove only fires once per render.
  }

  // Hook the parent's Remove link (or the engagement-ring "Remove setting"
  // link) so cascade-removing addons happens before the navigation.
  function bindCascade(removeAnchor, addons){
    if (!removeAnchor || removeAnchor.__spCascade) return;
    removeAnchor.__spCascade = true;
    removeAnchor.addEventListener('click', function(e){
      e.preventDefault();
      var href = removeAnchor.getAttribute('href');
      var chain = Promise.resolve();
      addons.forEach(function(ad){
        chain = chain.then(function(){
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id: ad.key, quantity: 0 }),
            credentials: 'same-origin'
          });
        });
      });
      chain.then(function(){ window.location.href = href; })
           .catch(function(){ window.location.href = href; });
    });
  }

  function runNest(){
    if (!document.querySelector('.sw-item') && !document.querySelector('.sw-ring-group')) return;
    fetch('/cart.js', { headers: {'Accept':'application/json'}, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var itemsByKey = {};
        var addonsByParentHandle = {};
        cart.items.forEach(function(it){
          itemsByKey[it.key] = it;
          var p = (it.properties || {})._addon_for;
          if (p){ (addonsByParentHandle[p] = addonsByParentHandle[p] || []).push(it); }
        });

        // ── Pass 1: engagement-ring groups (.sw-ring-group) ──
        // Each group has a "Remove setting" link whose id= param is the
        // setting's cart key. We resolve the setting's handle from that.
        document.querySelectorAll('.sw-ring-group').forEach(function(group){
          if (group.querySelector('[data-sp-cart-nest]')) return;
          var removeSettingLink = group.querySelector('.sw-ring-group__eyebrow-actions a');
          if (!removeSettingLink) return;
          var href = removeSettingLink.getAttribute('href') || '';
          var m = href.match(/[?&]id=([^&]+)/);
          if (!m) return;
          var settingKey = decodeURIComponent(m[1]);
          var settingItem = itemsByKey[settingKey];
          if (!settingItem) return;
          var myAddons = addonsByParentHandle[settingItem.handle];
          if (!myAddons || !myAddons.length) return;

          // Inject the Includes block. Prefer above the "crafted to order"
          // note so it reads as part of the ring summary.
          var anchor = group.querySelector('.sw-ring-group__craft') || null;
          var tmp = document.createElement('div');
          tmp.innerHTML = buildIncludesHtml(myAddons).trim();
          var node = tmp.firstChild;
          if (anchor){ anchor.parentNode.insertBefore(node, anchor); }
          else { group.appendChild(node); }

          // Now hide the standalone addon rows and cascade-remove on setting removal.
          myAddons.forEach(function(a){ hideAddonRow(a.key); });
          bindCascade(removeSettingLink, myAddons);
        });

        // ── Pass 2: standalone .sw-item parents (legacy / non-paired) ──
        cart.items.forEach(function(it){
          if ((it.properties || {})._addon_for) return;  // addons handled elsewhere
          var myAddons = addonsByParentHandle[it.handle];
          if (!myAddons || !myAddons.length) return;

          var rows = document.querySelectorAll('.sw-item[data-key="' + it.key + '"]');
          rows.forEach(function(row){
            if (row.querySelector('[data-sp-cart-nest]')) return;
            var body = row.querySelector('.sw-item__body');
            if (!body) return;
            var anchor = body.querySelector('.sw-item__props')
                      || body.querySelector('.sw-item__meta')
                      || body.querySelector('.sw-item__top');
            var tmp = document.createElement('div');
            tmp.innerHTML = buildIncludesHtml(myAddons).trim();
            var node = tmp.firstChild;
            if (anchor && anchor.nextSibling){
              anchor.parentNode.insertBefore(node, anchor.nextSibling);
            } else {
              body.appendChild(node);
            }
            myAddons.forEach(function(a){ hideAddonRow(a.key); });
            var removeLink = row.querySelector('.sw-item__remove-btn');
            bindCascade(removeLink, myAddons);
          });
        });

        // Anything left un-hidden stays visible. That's intentional — if
        // we couldn't find a parent to nest into, the shopper still sees
        // what is in their cart and checkout math lines up with display.

        // Nesting shortens the left column. If the theme's matchHeight
        // cached a stale min-height on the layout (run once at page load),
        // the right-side sidebar can clip visually. Re-sync it here and
        // nudge the theme to recompute via a resize event for safety.
        syncLayoutHeight();
        try { window.dispatchEvent(new Event('resize')); } catch(_){}
      })
      .catch(function(e){ console.warn('[sp-cart-nest]', e); });
  }

  function syncLayoutHeight(){
    var layout  = document.querySelector('.sw-cart__layout');
    var sidebar = document.getElementById('swCartSidebar');
    if (!layout || !sidebar) return;
    var h = sidebar.offsetHeight;
    if (h > 0) layout.style.minHeight = h + 'px';
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', runNest);
  } else {
    runNest();
  }

  ['cart:refresh','cart:updated','cart:build','refresh:cart'].forEach(function(n){
    document.addEventListener(n, function(){ setTimeout(runNest, 40); });
  });

  var obsTimer = null;
  var observer = new MutationObserver(function(mutations){
    var touched = false;
    for (var i = 0; i < mutations.length; i++){
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++){
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && (n.classList.contains('sw-item') || n.classList.contains('sw-ring-group'))) { touched = true; break; }
        if (n.querySelector && (n.querySelector('.sw-item') || n.querySelector('.sw-ring-group'))) { touched = true; break; }
      }
      if (touched) break;
    }
    if (!touched) return;
    clearTimeout(obsTimer);
    obsTimer = setTimeout(runNest, 60);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.spCartNest = runNest;
})();
